import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconEducation(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.479 3.261a1 1 0 0 0-.958 0l-8.91 4.86a1 1 0 0 0 0 1.757l1.868 1.018a1 1 0 0 1 .521.878v4.813a1 1 0 0 0 .521.877l6 3.275a1 1 0 0 0 .958 0l6-3.275a1 1 0 0 0 .521-.877v-4.813a1 1 0 0 1 .521-.878L21 10.09V16a1 1 0 1 0 2 0V9.594a1 1 0 0 0-.521-.878l-10-5.455ZM18.82 9l-6.341 3.459a1 1 0 0 1-.958 0L5.18 9l6.341-3.459a1 1 0 0 1 .958 0L18.82 9ZM17 15.397a1 1 0 0 1-.52.877l-4 2.184a1 1 0 0 1-.96 0l-4-2.184a1 1 0 0 1-.52-.877V12.27l4.52 2.468a1 1 0 0 0 .96 0L17 12.27v3.127Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
